/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TEXT 2 STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniqueanswer: {
		background: 'rgba(255,255,255,0.30)', // removed in animations for selected answer (so we don't have overlapping backgrounds)
		display: 'table',
		position: 'relative',
		width: '100%',
		transition: 'background .2s linear 0s',
		'&:hover': {
			background: 'rgba(255,255,255,0.50)',
		}
	},
	desc: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		justifyContent: 'space-evenly',
		zIndex: '2',
		height: pxToEm(30),
		margin: '0 auto',
		padding: replacePXinStringWithEM('0px 10px'),
		lineHeight: '0',
		color: '#fff',
		'& .text': {
			width: '90%',
			wordBreak: 'break-all'
		},
		'& .icon': {
			background: 'rgba(255,255,255,0.20)',
			borderRadius: '50%',
			width: pxToEm(10),
			height: pxToEm(10)
		},
		'& .text.large': {
			fontSize: pxToEm(11),
			lineHeight: pxToEm(15)
		},
		'& .text.medium': {
			fontSize: pxToEm(13),
			lineHeight: pxToEm(16)
		},
		'& .text.standard': {
			fontSize: pxToEm(16),
			lineHeight: pxToEm(16)
		}
	}
};




